import { ChangeDetectionStrategy, Component, Input, TemplateRef } from "@angular/core";
import { ɵNzTabBodyComponent } from "ng-zorro-antd/tabs";

@Component({
  selector: "[ui-tab-body]",
  exportAs: "uiTabBody",
  templateUrl: "./tab-body.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "ant-tabs-tabpane",
    "[class.ant-tabs-tabpane-active]": "active",
    "[attr.tabindex]": "-1",
    "[attr.aria-hidden]": "!active",
    "[style.visibility]": 'tabPaneAnimated && !active ? "hidden" : null',
    "[style.height]": "tabPaneAnimated && !active ? 0 : null",
    "[style.overflow-y]": 'tabPaneAnimated && !active ? "none" : null',
    "[style.display]": '!tabPaneAnimated && !active ? "none" : null',
  },
})
export class UiTabBodyComponent extends ɵNzTabBodyComponent {
  @Input() public content: TemplateRef<void> | null = null;
  @Input() public active = false;
  @Input() public tabPaneAnimated = true;
  @Input() public forceRender = false;
}
